import { components } from 'react-select';
import React from 'react';
import IconHandler from 'components/common/icon/IconHandler';
import { Box, Stack } from '@mui/material';

export const ReactSelectSingleValue = (props: any) => {
    const descRight = props.data.props?.desc_right;
    return (
        <components.SingleValue {...props}>
            <Stack direction="row" justifyContent={'flex-start'} alignItems={'center'}>
                {props.data?.props?.displayIcon !== false && props.data.props?.icon && (
                    <Box
                        sx={{
                            mr: 1,
                            width: '16px',
                            height: '16px',
                            display: 'inline-flex',
                            fontSize: props.data.props.icon.type == 'mi' ? '16px' : '14px',
                        }}
                    >
                        <IconHandler icon={props.data.props?.icon} />
                    </Box>
                )}
                <Box>
                    {props.children}
                    {descRight && <> ({descRight})</>}
                </Box>
            </Stack>
        </components.SingleValue>
    );
};
